module.exports = __webpack_public_path__ + "img/shoot_00034.ee7b4cbb.png";